import { NgClass } from '@angular/common';
import { Component, input, ViewEncapsulation } from '@angular/core';

import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

import type { IconGridItem } from './icon-grid.interface';

@Component({
	encapsulation: ViewEncapsulation.None,
	imports: [SVG_ICON_IMPORTS, NgClass],
	selector: 'vp-icon-grid',
	templateUrl: './icon-grid.html',
})
export class IconGridComponent {
	items = input<IconGridItem[]>([]);
}
